import React from "react";
import "./Orders.scss";
import Sidebar from "../Sidebar/Sidebar";
import { Link } from "react-router-dom";
import axios from "axios";
import * as backendModule from "../../modules/backendModule";
import Spinner from "../Spinner";
import moment from "moment";

const Orders = () => {

    const [data, setData] = React.useState(null);
    const [spinner, setSpinner] = React.useState(false);
    const [deleteSpinner, setDeleteSpinner] = React.useState(false);
    const [error, setError] = React.useState(null);

    const getAllOrders = () => {
        setSpinner(true);
        axios({
            method: "POST",
            url: `${backendModule.backendURL}/orders/getAllOrders`,
            data: {
                filters: [],
            },
            ...backendModule.axiosConfig,
        }).then(res => {
            if (res.data.status === "ok") {
                setData(res.data?.data);
            } else {
                setError('Došlo je do serverske greške');
            }
        }).catch(() => {
            setError('Došlo je do serverske greške');
        }).finally(() => {
            setSpinner(false);
        });
    }

    React.useEffect(() => {
        getAllOrders();
    }, []);

    return (
        <div className="orders">
            <Sidebar />
            <div className="orders__container">
                {!error && !spinner ? <div className="ordersTableWrapper">
                    <table className="ordersTable">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Ime</th>
                                <th>Prezime</th>
                                <th>Grad</th>
                                <th>Ukupna cijena</th>
                                <th>Status</th>
                                <th>Datum</th>
                                <th>Akcija</th>
                            </tr>
                        </thead>

                        <tbody>
                            {data?.map((order, index) => (
                                <tr key={index}>
                                    <td>{order.ID}</td>
                                    <td>{order.FirstName}</td>
                                    <td>{order.LastName}</td>
                                    <td>{order.City}</td>
                                    <td>{order.TotalPrice} KM</td>
                                    <td>{order.Status == 0 ? 'Na čekanju' : order.Status == '1' ? 'Poslano' : 'Isporučeno'}</td>
                                    <td>{moment(order.createdAt).format('D.M.YYYY.')}</td>
                                    <td>
                                        <Link to={`/admin/orders/orderInfo?orderId=${order.ID}`}>
                                            VIŠE
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div> : null}
                {error && <p>{error}</p>}
                {spinner && <Spinner style={{ width: '64px', height: '50px', color: 'black' }} color="black" />}
            </div>
        </div>
    );
};

export default Orders;
